import React, { useState, useEffect } from 'react';
import { baseCss } from '../css';

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const imobileRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
const ccRegex = /^(\+?\d{1,3}|\d{1,4})$/;

export const isValidEmail = email => emailRegex.test(email);
export const isValidIndianMobile = mobile => Number.isInteger(parseInt(mobile)) && mobile?.toString().length === 10;

export const isValidOtherMobile = mobile => imobileRegex.test(mobile?.toString());
export const isValidCC = cc => ccRegex.test(cc);

const Input = ({ type = 'text', value, onChange, errMsg, label, validation, disabled, autoFocus, max }) => {
    const [isFocus, setFocus] = useState(false);
    const [valid, setValid] = useState(false);
    const [isBlur, setBlur] = useState(false);

    const validator = (val) => {
        if (validation === 'email') {
            setValid(isValidEmail(val));
            return (val);
        }
        if (validation === 'mobile') {
            if ((Number.isInteger(parseInt(val)) || !val) && val?.length < 11) {
                setValid(isValidIndianMobile(val));
                return (parseInt(val) || '');
            }
        }

        if (validation === 'imobile') {
            if (val.length < 15) {
                setValid(val.length > 6);
                return (parseInt(val) || '');
            }
        }
        if (validation === 'otp') {
            if (val.length < 7) {
                setValid(val.length >= 4);
                return (parseInt(val) || '');
            }
        }
        if (validation === 'pnr' || validation === 'ticket') {
            if (val.length < 20) {
                return val;
            }
        }

        if (validation === 'utr') {
            if (val.length < 40) {
                return val;
            }
        }
        if (validation === 'cc') {
            if (val.length < 5 && (!isNaN(val) || val === '+' || val === '')) {
                setValid(isValidCC(val));
                return (val);
            }
        }
        if (!validation) {
            setValid(true);
            return (val)
        }
        return false;
    }

    useEffect(() => {
        validator(value);
    })

    const handleBlur = () => {
        setFocus(false);
        setBlur(true);
    }

    const handleChange = (e) => {
        const val = e.target.value;
        if (validator(val) || validator(val) === '') {
            onChange(validator(val));
        }
    }

    const activeStyle = {
        borderWidth: 1,
        ...baseCss.inputborderColor
    }

    return (
        <div className={`inp-container${isFocus || (isBlur && !valid) ? ' extra' : ''}${isBlur && !valid ? ' err' : ''}${disabled ? ' disabled' : ''}`}>
            <input
                type={type}
                value={value}
                onChange={handleChange}
                onFocus={() => setFocus(true)}
                onBlur={handleBlur}
                style={isFocus ? activeStyle : {}}
                disabled={disabled}
                autoFocus={autoFocus}
                autoComplete='off'
                maxLength={max}
            />
            <label
                className={`${isFocus || value?.toString().length > 0 ? 'active' : ''}`}
                style={isFocus ? baseCss.defaultInputColor : {}}
            >{label}</label>
            {
                !isFocus && isBlur && !valid &&
                <span>{errMsg}</span>
            }
        </div>
    )
}

export default Input;